import ic_cross from '@/assets/images/icons/cross.svg';
import { Modal } from '@/components/shared';
import { Order } from '@/types';
import { bem, dayOfWeeks, doubleDigestNumer } from '@/utilities';
import React from 'react';

type Props = {
  openModal: boolean;
  order?: Order;
  onClickCloseModal: () => void;
  onClickSubmitButton: (orderId: number) => void;
};

export const OrderCancelModal: React.FC<Props> = (props) => {
  const { openModal, order, onClickCloseModal, onClickSubmitButton } = props;

  const formattedScheduledAtDate = () => {
    const dateScheduledAt = new Date(order.scheduledAt);
    const endAt = new Date(dateScheduledAt.getTime() + order.duration * 1000 * 60);

    return (
      `${dateScheduledAt.getFullYear()}年${dateScheduledAt.getMonth() + 1}月` +
      `${dateScheduledAt.getDate()}日（${dayOfWeeks[dateScheduledAt.getDay()]}） ` +
      `${dateScheduledAt.getHours()}:${doubleDigestNumer(dateScheduledAt.getMinutes())}〜` +
      `${endAt.getHours()}:${doubleDigestNumer(endAt.getMinutes())}`
    );
  };

  if (!openModal || !order) return <></>;

  return (
    <Modal isOpen={openModal} onClickOverlay={() => onClickCloseModal()}>
      <div className={bem('modal', 'close-icon')} onClick={() => onClickCloseModal()}>
        <img src={ic_cross} />
      </div>
      <p className={bem('order-cancel-modal', 'title')}>予約の取り消し</p>
      <p className={bem('order-cancel-modal', 'description')}>
        予約を取り消してよろしいでしょうか？
        <br />
        取り消した予約は、再度日程調整をしてください。
      </p>
      <p className={bem('order-cancel-modal', 'schedule')}>{formattedScheduledAtDate()}</p>
      <div className={bem('order-cancel-modal', 'info')}>
        <div className={bem('order-cancel-modal', 'car')}>
          <p className={bem('order-cancel-modal', 'car-text')}>{order.ownedCar.carNumber}</p>
          <p className={bem('order-cancel-modal', 'car-text')}>
            <span>{order.ownedCar.carModelName}</span>
            <span>{order.ownedCar.carModelNumber}</span>
          </p>
        </div>
        <p className={bem('order-cancel-modal', 'name')}>{`${order.userName}様`}</p>
        <p className={bem('order-cancel-modal', 'location')}>{order.location}</p>
        <p className={bem('order-cancel-modal', 'time')}>{`${order.duration}分`}</p>
      </div>
      <div className={bem('order-cancel-modal', 'buttons')}>
        <button className={bem('order-cancel-modal', 'close-button')} onClick={() => onClickCloseModal()}>
          閉じる
        </button>
        <button className={bem('order-cancel-modal', 'cancel-button')} onClick={() => onClickSubmitButton(order.id)}>
          予約を取り消す
        </button>
      </div>
    </Modal>
  );
};
